import { DataBean } from "../DataBean";

export class Certificate extends DataBean {

    public async getCertificateByCode(type: any,idAccount:any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.admin.Certificate_getCertificateByCode_Number_Number", [type,idAccount]);
    }
    public async getCertificateCatalog(nit:any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getCertificateCatalog_Number", [nit]);
    }
    public async getCertificateTypes(id:any): Promise<any> {
        return this.getCustomService("OrangeCore", "java.util.List_getCertificateTypes_Number", [id]);
    }

    public async saveCertificate(idAccount: any,type:any,password:any,filename:any,disrectory:any,dataStore:any): Promise<any> {
        return this.getCustomService("OrangeCore", "com.orange.bean.admin.Certificate_saveCertificate_Number_Number_String_String_String_String", [idAccount,type,password,filename,disrectory,dataStore]);
    }

}
